import React from "react";
import { motion } from "framer-motion";

const SolutionHeader = () => {
  return (
    <div className="space-y-2 sm:space-y-3">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="space-y-2 sm:space-y-3"
      >
        <h1 className="relative text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-[TAEBAEKfont] drop-shadow-2xl text-white cursor-pointer text-center sm:text-left
                       after:block after:absolute after:top-[60%] after:left-[0%] after:right-[18%] after:-skew-y-2 after:bg-red-500 after:z-[-1] after:h-[7px] sm:after:h-[10px] lg:after:h-[14px]
                       after:transition-all after:duration-300 hover:after:bg-red-400 hover:after:right-[20%] mb-1 sm:mb-2">
          SOLUTION
        </h1>
        <p className="text-sm sm:text-base lg:text-lg text-gray-200 font-[SUIT-Regular] text-center sm:text-left">
          맞춤형 솔루션으로 비즈니스 혁신을 실현합니다
        </p>
      </motion.div>
    </div>
  );
};

export default SolutionHeader; 